"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DepositResumeOperationSummary = exports.CrossResumeOperationSummary = exports.StakingOperationSummary = exports.CrossOperationSummary = exports.ChainOperationSummary = void 0;
const executable_1 = require("./executable");
class AbstractOperationSummary {
    operation;
    fees;
    spendings;
    values;
    errors;
    executable;
    constructor(provider, operation, fees, spendings, values, errors) {
        this.operation = operation;
        this.fees = fees;
        this.spendings = spendings;
        this.values = values;
        this.executable = new executable_1.ExecutableOperation(provider);
        this.errors = errors;
    }
    getExecutable() {
        return this.executable;
    }
    getAssets() {
        const assets = new Set();
        // refresh balances of all sent assets to sync it
        for (const asset of this.spendings) {
            const assetId = asset.assetId;
            if (!assets.has(assetId)) {
                assets.add(assetId);
            }
        }
        // refresh balances of all created values in case it was sent to self
        for (const [assetId] of this.values) {
            if (!assets.has(assetId)) {
                assets.add(assetId);
            }
        }
        return assets;
    }
    getErrors() {
        return this.errors;
    }
}
class ChainOperationSummary extends AbstractOperationSummary {
    operation;
    chain;
    fee;
    constructor(provider, operation, chain, fee, spendings, values, errors = []) {
        super(provider, operation, [fee], spendings, values, errors);
        this.operation = operation;
        this.chain = chain;
        this.fee = fee;
    }
    getChains() {
        return [this.chain];
    }
}
exports.ChainOperationSummary = ChainOperationSummary;
class CrossOperationSummary extends AbstractOperationSummary {
    operation;
    chains;
    constructor(provider, operation, chains, fees, spendings, values, errors = []) {
        super(provider, operation, fees, spendings, values, errors);
        this.operation = operation;
        this.chains = chains;
    }
    getChains() {
        return this.chains;
    }
}
exports.CrossOperationSummary = CrossOperationSummary;
class StakingOperationSummary extends ChainOperationSummary {
    potentialReward;
    constructor(provider, operation, chain, fee, spendings, values, potentialReward, errors = []) {
        super(provider, operation, chain, fee, spendings, values, errors);
        this.potentialReward = potentialReward;
    }
}
exports.StakingOperationSummary = StakingOperationSummary;
class CrossResumeOperationSummary extends ChainOperationSummary {
    operation;
    importFee;
    payImportFee;
    utxoSet;
    constructor(provider, operation, importFee, spendings, values, payImportFee, utxoSet, errors = []) {
        super(provider, operation, operation.destination, importFee, spendings, values, errors);
        this.operation = operation;
        this.importFee = importFee;
        this.payImportFee = payImportFee;
        this.utxoSet = utxoSet;
    }
}
exports.CrossResumeOperationSummary = CrossResumeOperationSummary;
class DepositResumeOperationSummary extends ChainOperationSummary {
    operation;
    fee;
    constructor(provider, operation, fee, spendings, values, errors = []) {
        super(provider, operation, operation.chain, fee, spendings, values, errors);
        this.operation = operation;
        this.fee = fee;
    }
}
exports.DepositResumeOperationSummary = DepositResumeOperationSummary;
